import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter, redirect } from "react-router";
import "@oc/design-tokens/tokens.css";
import "@oc/design-tokens/additions.css";
import "@oc/ui/ui.css";
import "./landing.css";
import "./site.css";
import { h } from "@oc/ui";
import { RegionLayout, NotFound } from "./layout.ts";
import { LandingPage } from "./pages/landing.ts";
import { ReviewPage } from "./pages/review.ts";
import { DetailsPage } from "./pages/details.ts";
import { LegalPage } from "./pages/legal.ts";
import { IntakePage } from "./pages/intake.ts";
import { ResearchIndexPage, ResearchNotePage, SubmitPage } from "./pages/research.ts";
import { ActiveOffersPage } from "./pages/active-offers.ts";
import { HelpPage } from "./pages/help.ts";
import { RequestReportPage } from "./pages/request-report.ts";
import { OfferPage } from "./pages/offer.ts";

export const routes = [
  // Cloudflare picks the region by geography in production; the bare root goes to Australia.
  { path: "/", loader: () => redirect("/au") },
  {
    path: "/:region", Component: RegionLayout,
    children: [
      { index: true, Component: LandingPage },
      { path: "review", Component: ReviewPage },
      { path: "details", Component: DetailsPage },
      { path: "legal", Component: LegalPage },
      { path: "start", Component: IntakePage },
      { path: "research", Component: ResearchIndexPage },
      { path: "active-offers", Component: ActiveOffersPage },
      { path: "offers/:platform/:externalRef", Component: OfferPage },
      { path: "request-report", Component: RequestReportPage },
      { path: "research/:slug", Component: ResearchNotePage },
      { path: "submit", Component: SubmitPage },
      { path: "help", Component: HelpPage },
      // ADR-013: the emailed link that opens a voice conversation in this browser. Loaded only when
      // somebody opens one — the voice client is tens of kilobytes that a visitor reading the
      // landing page on a phone should never have to fetch.
      { path: "talk/:token", lazy: async () => ({ Component: (await import("./pages/talk.ts")).TalkPage }) },
    ],
  },
  { path: "*", Component: NotFound },
];

createRoot(document.getElementById("root")!).render(h(RouterProvider, { router: createBrowserRouter(routes) }));
